import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'prf-teacher-welcome-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './teacher-welcome-popup.component.html',
  styleUrls: ['./teacher-welcome-popup.component.scss'],
})
export class TeacherWelcomePopupComponent {
  @Output() private isClosedPopup: EventEmitter<boolean> = new EventEmitter<boolean>();

  public closePopup(): void {
    this.isClosedPopup.emit(true);
  }
}
